import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-user-role',
  templateUrl: './add-user-role.component.html',
  styleUrls: ['./add-user-role.component.scss']
})
export class AddUserRoleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
